(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["falcon-free-shipping-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('falcon-shipping-progress')) {
    customElements.define('falcon-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        const configElement = this.querySelector('[data-falcon-shipping-config]');
        if (!configElement) return;
        let config;
        try {
          config = JSON.parse(configElement.textContent);
        } catch {
          return;
        }
        if (!['AU', 'NZ'].includes(config.country) || !Number.isFinite(config.totalPrice)) return;

        const currency = config.currency || config.baseCurrency;
        const exchangeRate = Number(window.Shopify?.currency?.rate);
        const threshold = currency !== config.baseCurrency
          ? Math.ceil(config.threshold * exchangeRate)
          : config.threshold;
        if (!Number.isFinite(threshold) || threshold <= 0) return;

        const money = new Intl.NumberFormat(config.locale || 'en', {
          style: 'currency',
          currency,
          currencyDisplay: 'code'
        });
        const formatMoney = (cents) => money.format(cents / 100);
        const total = Math.max(0, config.totalPrice);
        const remaining = Math.max(0, threshold - total);
        const percent = Math.min(100, total / threshold * 100);
        const message = this.querySelector('.falcon-shipping-popup__message');
        const track = this.querySelector('.falcon-shipping-popup__track');
        const totals = this.querySelector('.falcon-shipping-popup__totals');

        message.textContent = remaining > 0
          ? config.pendingMessage.replace('[amount]', formatMoney(remaining))
          : config.successMessage;
        totals.textContent = config.totalsMessage
          .replace('[total]', formatMoney(total))
          .replace('[goal]', formatMoney(threshold));
        track.setAttribute('aria-valuenow', percent.toFixed(1));
        track.setAttribute('aria-valuetext', message.textContent);
        this.style.setProperty('--falcon-shipping-progress', percent + '%');
        this.classList.toggle('is-complete', remaining === 0);
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
